/**
 * useAuth Hook
 * 
 * Custom hook to access authentication context.
 * Provides user state, authentication status, and auth actions.
 * 
 * @example
 * const { user, isAuthenticated, login, logout } = useAuth();
 */

import { useContext } from 'react';
import { AuthContext } from './AuthContext';

export const useAuth = () => {
  const context = useContext(AuthContext);

  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }

  return context;
};
